import React from 'react';
import PropTypes from 'prop-types';
import Link from '../components/Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import Section, { Title, Content } from './Section';

const ShortcutsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ShortcutItem = styled(Link)`
  flex: 0 0 50%;
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.125rem;
  font-weight: ${p => (p.featured ? '700' : '500')};
  line-height: 1;
  text-decoration: none;
  padding: 0 5px;
  margin-bottom: 20px;
  transition: color 0.5s, border-color 0.5s;

  ${breakpoints.medium`
    flex: 0 0 33.33%;
  `};

  ${breakpoints.large`
	flex: 0 0 20%;
	max-width: 20%;
  `};

  &:hover span {
    color: ${p => p.theme.colors.primary};
    border-bottom-color: ${p => p.theme.colors.primary};
  }
`;

const ShortcutItemLabel = styled.span`
  padding-bottom: 15px;
  display: block;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${p =>
    p.featured ? p.theme.colors.primary : p.theme.colors.border};
`;

export default function CarBrandsListSection({ brands }) {
  const renderBrandsList = brands.map(({ id, url, name, isFeatured }) => (
    <ShortcutItem key={id} to={url} featured={isFeatured ? 1 : 0}>
	  <ShortcutItemLabel>{name}</ShortcutItemLabel>
    </ShortcutItem>
  ));

  return (
    <Section>
      <Title>Velg bilmerke</Title>

      <Content>
        <ShortcutsGrid>{renderBrandsList}</ShortcutsGrid>
      </Content>
    </Section>
  );
}

CarBrandsListSection.propTypes = {
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isFeatured: PropTypes.bool.isRequired
    })
  )
};
